import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import AdminPanel from './pages/AdminPanel';
import ResidentPanel from './pages/ResidentPanel';
import GuardPanel from './pages/GuardPanel';
import './App.css';

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="spinner" style={{ minHeight: '100vh' }} />;
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }

  // Redirigir según rol
  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" />} />
      <Route
        path="/*"
        element={
          user.rol === 'admin' ? <AdminPanel /> :
          user.rol === 'vigilante' ? <GuardPanel /> :
          <ResidentPanel />
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app-container">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
}